import React, { useEffect, useLayoutEffect, useState } from "react";
import BlogCard from "../../Components/BlogComp/BlogCard";
import SocialFeed from "../../Components/BlogComp/SocialFeed";
import { BlogSlider } from "../../Components/BlogComp/BlogSlider";
import SubNav from "../../Layout/SubNav";
import axios from "axios";
import "./Blog.css";
import Loader from "../../Components/Loader";
import Footer from "../../Layout/Footer";

const Blog = () => {
  const [data, setData] = useState();

  useEffect(async () => {
    const res = await axios.get("https://staging-cms-main.ipurvey.com/blogs");
    const layout = await axios.get(
      "https://staging-cms-main.ipurvey.com/layout"
    );
    const boo = await axios.get(
      "https://staging-cms-main.ipurvey.com/blogs-page"
    );
    setData([res.data, layout.data, boo.data]);
  }, []);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  if (data) {
    return (
      <>
        <div className="blog_container">
          <SubNav head="ipurvey Blog" />
          <div className="blog_main_div">
            <div className="event_slider_div">
              <BlogSlider data={data[2]} />
            </div>
            <div className="blog_card_socail_feed_div margin_top">
              <BlogCard size="15" show data={data[0]} />
              <SocialFeed />
            </div>
          </div>
        </div>
        <Footer data={data[1]} />
      </>
    );
  } else return <Loader />;
};

export default Blog;
